import React from 'react';
import Fallback from './Fallback';

// getDerivedStateFromError는 훅으로 구현되어있지 않아서 컴포넌트 형식을 사용한다.
// https://reactjs.org/docs/hooks-faq.html#do-hooks-cover-all-use-cases-for-classes

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { errorMessage, children } = this.props;

    if (hasError) {
      return <Fallback errorMessage={errorMessage} />;
    }

    return children;
  }
}

export default ErrorBoundary;
